import styled from "styled-components";

export const NotFoundContainer = styled.div`
  flex: 1 1;
  display: flex;
  height: 100vh;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  background-color: #212427;
`;

export const Title = styled.div`
  font-size: 32px;
  color: #fff;
  line-height: 1.4;
  padding-left: 15px;
  padding-right: 15px;
`;

export const Description = styled.div`
  font-size: 16px;
  color: #939393;
  font-weight: 400;

  text-align: center;
  line-height: 1.4;
  padding-left: 15px;
  padding-right: 15px;
`;
